<template>
  <div class="productQuotationApplicationAdd container">
    <div class="searchBox">
      <div>
        <el-button size="mini" class="btn" type="primary" v-acl="Sourcing-productSubmit" @click="submitData">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="goBack">{{$t('common.close')}}</el-button>
      </div>
      <el-form label-width="140px" ref="applyInfoForm" :model="headData" inline style="margin-top:20px">
        <el-form-item label="报价确认单据编号">
          <el-input class="handle-input" v-model="headData.sourcingNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="产品报价申请单">
          <el-input class="handle-input" v-model="headData.applyNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="主题">
          <el-input class="handle-input" v-model="headData.subject" disabled></el-input>
        </el-form-item>
      </el-form>
    </div>
    <ux-grid ref="proList" data="proList" max-height="650" show-overflow="tooltip" highlight-current-row>
      <ux-table-column align="center" type="checkbox" width="80" />
      <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
      <ux-table-column align="center" v-for="(item,index) in columns" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width" />
      <ux-table-column align="center" title="非标准线路运费" field="isSpecialFreight" min-width="120">
        <template v-slot="scope">
          {{scope.row.isSpecialFreight |setIsSpecialFreight}}
        </template>
      </ux-table-column>
      <ux-table-column align="center" title="到货仓库" field="tmDcId" min-width="120">
        <template v-slot="scope">
          {{scope.row.tmDcId|ic("BASE","DC")}}
        </template>
      </ux-table-column>
      <ux-table-column align="center" title="温区" field="temperature" min-width="100">
        <template v-slot="scope">
          {{scope.row.temperature|ic("COMMON","TEMPERATURE")}}
        </template>
      </ux-table-column>
      <ux-table-column align="center" v-for="(item,index) in columns1" :key="index" resizable :field="item.prop" :title="item.label" sortable :min-width="item.width" />
    </ux-grid>
  </div>
</template>
<script>
import { getSourcingList, sourcingSubmit } from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import { fileService } from "@/api/common/file-utils";
export default {
  name: "sourcingByProduct",
  data() {
    return {
      radioVal: null,
      selectRow: null,
      ttQuotationId: "",
      headData: {},
      sourcingNo: "",
      proList: [],
      fileList: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      columns: [
        { prop: "eightBitCode", label: "8位码", width: "100" },
        { prop: "eightBitCodeName", label: "8位码名称", width: "120" },
        { prop: "supplierName", label: "入围供应商", width: "120" },
        { prop: "productPrice", label: "产品运费（不含税）", width: "180" },
        { prop: "currentProductPrice", label: "现有产品价格", width: "150" },
        { prop: "changeRate", label: "价格变化", width: "120" },
        { prop: "effectiveBeginDate", label: "有效开始日期", width: "150" },
      ],
      columns1: [
        { prop: "transportaionMethodI18n", label: "运输方式", width: "120" },
        { prop: "leadTime", label: "LeadTime", width: "120" },
        { prop: "unitI18n", label: "结算单位", width: "120" },
        { prop: "linePrice", label: "线路价格", width: "120" },
        { prop: "currencyCode", label: "币种", width: "120" },
        { prop: "remarks", label: this.$t('common.remarks'), width: "120" },
        { prop: "estimatedAnnualFee", label: this.$t('apply.estimatedAnnualTotalCost'), width: "170" },
      ]
    };
  },
  filters: {
    setIsSpecialFreight(key) {
      if (key == 'Y') {
        return '是'
      } else if (key == 'N') {
        return '否'
      } else {
        return key
      }
    },
  },
  created() {
    this.ttQuotationId = this.$route.query.ttQuotationId;
    this.quotationPageInitM(this.$route.query.ttQuotationId);
  },
  methods: {
    quotationPageInitM: function (ttQuotationId) {
      let _this = this;
      getSourcingList(ttQuotationId).then(res => {
        _this.sourcingNo = res.sourcingNo;
        _this.headData = res.quotationApply;
        _this.proList = res.proList;
        this.$refs.proList.reloadData(res.proList)
        _this.headData.sourcingNo = res.sourcingNo;
        if (_this.proList.length > 0) {
          _this.$nextTick(() => {
            for (let i = 0; i < _this.proList.length; i++) {
              let pro = _this.proList[i];
              console.log(1);
              if (_this.proList.filter(item => {
                return item.eightBitCode == pro.eightBitCode && item.dcName == pro.dcName
              }).length == 1) {
                _this.$refs.proList.toggleRowSelection(_this.proList[i]);
              }
            }
          })
        }

      });
    },
    submitData() {
      let flag = false
      let _this = this;
      let rows = this.$refs.proList.getCheckboxRecords();
      console.log('rows', rows);
      if (rows.length <= 0) {
        this.$message({ message: "请选择需要提交的", type: "warning" });
        return;
      } else {
        let ed = [];
        for (let i = 0; i < rows.length; i++) {
          let row = rows[i];
          if (ed.indexOf(row.eightBitCode + "_" + row.tmDcId) >= 0) {
            flag = true
          } else {
            ed.push(row.eightBitCode + "_" + row.tmDcId)
          }
        }
        if (flag) {
          _this.$message({ message: "每个(8位码+DC)只能有一家中标供应商", type: "warning" });
          return;
        }
        let ids = [];
        rows.forEach(item => {
          ids.push(item.ttQuotationProductId);
        });
        let data = {
          "sourcingNo": _this.sourcingNo,
          "ttQuotationId": _this.ttQuotationId,
          "ttQuotationProductIds": ids
        }
        console.log(data);
        sourcingSubmit(data).then(res => {
          console.log(res);
          if (res.meta.success) {
            _this.$message({
              message: _this.$t("quoteByLine.sourcing.success"),
              type: "success"
            });
            this.$router.go(-1);
            // _this.$router.push({
            //   path: `/sourcingByProduct`,
            //   query: {
            //     ttQuotationId:_this.ttQuotationId,
            //   }
            // });
          } else {
            Message({ message: res.meta.msg, type: "warning" });
            //转到报价详情，让用户维护预估年总费用
            let roundId = _this.ttQuotationId;
            this.$router.push({
              path: `/inquiry-quotation-product-detail`,
              query: {
                applyId: roundId,
                from: "eq"
              }
            });
          }
        });
      }
    },
    goBack() {
      window.history.go(-1);
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.ttQuotationApplyId;
      attachment.tsReckindId = "QUOTATION_APPLY";
      fileService.getFileList(attachment).then(fileRes => {
        this.fileList = fileRes;
      });
    }
  }
};
</script>
<style lang="scss">
.productQuotationApplicationAdd .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
}
</style>
